import React, { lazy } from "react";

const LazyCorrectionsApprovals = lazy(() => import("./CorrectionsApprovals"));

const CorrectionsApprovals = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyCorrectionsApprovals {...props} />;

export default CorrectionsApprovals;
